<template>
  <div id="MarkOnly-style" class="Mark flex h-screen bg-cover">
    <div class="m-auto">
      <h1 class="text-6xl leading-none text-white text-blue-200 tracking-tighter">THE BOOK <br>FOR MARK <br>ZUCKERBERG</h1>
      <div class="mt-4">
        <input v-model="password" v-on:keyup.enter.prevent="submit()" class="w-full text-2xl border-2 border-blue-200 text-center text-white" type="password" name="password" value="" placeholder="Password">
        <button @click="submit()" style="font-weight: 700;"
        class="text-blue-300 bg-white mt-6 px-8 py-2 text-xl rounded-lg tracking-wider border-2 border-black bg-blue-200"
        type="button"
        name="button">
        Confirm
      </button>
    </div>
      <div v-if="succeeded" id="success" class="text-turquoise mt-4 text-xl">
        Enjoy the book Mark.
      </div>
      <div v-if="failed" id="fail" class="error-text mt-4 text-3xl">
        *Ask Mark
      </div>
    </div>
    <Navigation textColor="white"/>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import axios from 'axios';

export default {
  name: "ForMarkOnly",
  components:{
    Navigation
  },
  data(){
    return{
      password: '',
      endpoint: '/BookForm.php',
      succeeded: false,
      failed: false,
    }
  },
  methods:{
    submit(){

      this.succeeded = false;
      this.failed = false;

      axios.post(this.endpoint, {
        password: this.password
      })
      .then((response) => {
        this.succeeded = true;
        this.password = '';
        window.open(response.data.url);
      })
      .catch((error) => {
        this.failed = true;
        this.password = '';
        console.log(error);
      });
    }
  },
  mounted(){

    Event.$emit('playAudio', 'ForMarkOnly');
  }
}
</script>

<style lang="css" scoped>
.Mark{
  background-image: url('https://blissing.s3-us-west-1.amazonaws.com/img/BG_Mark.jpg');
}

input{
  background-color: #000;
}

.error-text{
  color: #df0d1a;
}
</style>
